// Port of api/fuel/app/classes/controller/api/monty/accounts/verify.php
import Constants from 'offline/constants'
import User from 'offline/model/user'

export default function(params) {
	var name = String(params.name || '').trim().toLowerCase()
	var key = String(params.key || '').replace(/\[/g, '')
	var user

	if (key) {
		user = User.with('user_verification_key', key)

		if (!user) {
			return Promise.reject({ error: Constants.API_ERROR_USER_KEY_INVALID, offline: true })
		}

		return Promise.resolve({
			session: { offline: true },
			data: { username: user.get_name() }
		})
	}

	if (!name || name === 'ynezzz') {
		return Promise.reject({ error: Constants.API_ERROR_USER_INVALID, offline: true })
	}

	user = User.with('user_name', name)

	if (!user) {
		return Promise.reject({ error: Constants.API_ERROR_USER_NOTFOUND, offline: true })
	}

	if (user.is_registered()) {
		return Promise.reject({ error: Constants.API_ERROR_USER_REGISTERED, offline: true })
	}

	return Promise.reject({ error: 'This action is not available offline.', offline: true })
}
